import { useState, useEffect, useRef } from "react";
import { NavItem, UncontrolledTooltip } from "reactstrap";
import useUserContext from "Hooks/useUserContext";
import styles from "components/NavMenu/Components/ProcoreStatus/ProcoreStatus.module.css";

interface StatusResponse {
    indicator: string;
    description: string;
}

export default function ProcoreStatus() {
    const [userContext] = useUserContext();
    const [status, setStatus] = useState<StatusResponse>({ indicator: "none", description: "All Systems Operational" });
    const dotRef = useRef<HTMLSpanElement>(null);

    const hasProcore = userContext.companySystems?.toLowerCase().includes("procore");

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await fetch("/api/procore_status");
                if (response.ok) {
                    const data = await response.json();
                    setStatus(data);
                }
            } catch {
                // silently ignore - dot stays green
            }
        };

        fetchStatus();
        const interval = setInterval(fetchStatus, 60_000);
        return () => clearInterval(interval);
    }, []);

    if (!hasProcore) return null;

    const indicatorClass = styles[status.indicator] || styles.none;

    return (
        <NavItem className={styles.container}>
            <a
                href="https://status.procore.com/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.dotLink}
            >
                <span
                    id="procoreStatusDot"
                    ref={dotRef}
                    className={`${styles.dot} ${indicatorClass}`}
                />
            </a>
            <UncontrolledTooltip target="procoreStatusDot">
                Procore: {status.description}
            </UncontrolledTooltip>
        </NavItem>
    );
}
